import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getApi } from "../../../api/api";
import { PromoInterface } from "../../../common/types/interfaces";


export const usePromoDetails = () => {
  const { id } = useParams<{ id: string }>();
  const [promo, setPromo] = useState<PromoInterface | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    let cancelled = false;
    setLoading(true);

    // Загружаем все акции и ищем нужную (пока нет отдельного эндпоинта)
    getApi()
      .getPromos({ limit: 10000 })
      .then((res) => {
        if (!cancelled) {
          const found = res.data.find((p) => p.id === Number(id));
          setPromo(found || null);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setPromo(null);
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return { promo, ready: !loading };
};
